import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IMerchant, IPagination } from "../../interfaces";

// Default pagination values
const PAGINATION = {
  page: 1,
  per_page: 999999999,
};

interface UsersResponse extends IPagination {
  results: IMerchant[];
}

export const useMerchants = (page?: number, perPage?: number) => {
  return useQuery<UsersResponse, Error>({
    queryKey: ["merchants", page, perPage],
    queryFn: async () => {
      const response = await httpService.get<UsersResponse>(
        API_CONFIG.path.users,
        {
          page: page || PAGINATION.page,
          per_page: perPage || PAGINATION.per_page,
        }
      );
      return response;
    },
  });
};
